import React, { useState } from 'react'
import { ArrowRight } from 'react-feather'
import FloGenericDialog from 'src/components/common/feedback-and-dialog/GenericDialog'
import { useActivityLogs, EntityName } from 'src/lib/hooks/useActivityLogs'
import { useUser } from 'src/lib/contexts/UserContext'

interface DisableRewardsProps {
  handleUpdateRewardConfig: (payload: any) => Promise<void>
}

const DisableRewards: React.FC<DisableRewardsProps> = ({ handleUpdateRewardConfig }) => {
  const { sendActivityLog } = useActivityLogs()
  const [showConfirmationDialog, setShowConfirmationDialog] = useState<boolean>(false)
  const { user } = useUser()

  return (
    <>
      <div
        className='flex items-center justify-between p-3 rounded-lg cursor-pointer border-1 border-[#cb271133]'
        onClick={() => {
          setShowConfirmationDialog(true)
        }}
      >
        <p className='text-red-dark'>Temporarily disable Shopflo Rewards</p>
        <ArrowRight className='h-4 w-4 stroke-[2.5px]' color={'#CB2711'} />
      </div>

      {Boolean(showConfirmationDialog) && (
        <FloGenericDialog
          width={800}
          isOpen={showConfirmationDialog}
          handleClose={() => setShowConfirmationDialog(false)}
          content={<p className='text-sm text-coal-dark'>Customers will not be able to earn or redeem any credits.</p>}
          referrer='disabl-rewards-confirmation'
          title={'Are you sure you want to disable Rewards?'}
          jobButtonText={'Disable rewards'}
          handleJob={async () => {
            await handleUpdateRewardConfig({ active: false })
            const activityLogPayload = {
              entityName: EntityName.REWARDS,
              actionName: 'disabled the configuration'
            }
            sendActivityLog(activityLogPayload)
            setShowConfirmationDialog(false)
          }}
          primaryBtnCss={
            !user?.isDemoUser ? { backgroundColor: '#CB2711 !important', outline: 'none', hover: 'none' } : ''
          }
        />
      )}
    </>
  )
}

export default DisableRewards
